import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { AmbientOrbs } from "./Ambient";
import { INDUSTRIES } from "@/lib/data";

export const Industries = () => (
  <section id="industries" className="relative overflow-hidden bg-white py-16 md:py-20" data-testid="industries-section">
    <AmbientOrbs />
    <div className="relative mx-auto max-w-5xl px-5 text-left lg:px-8">
      <Reveal>
        <span className="inline-flex items-center rounded-full border border-emerald2-300/40 bg-emerald2-500/10 px-4 py-1.5 text-xs font-bold uppercase tracking-[0.2em] text-emerald2-600">
          Industries We Serve
        </span>
      </Reveal>
      <Reveal delay={0.05}>
        <h2 className="mt-4 max-w-2xl text-3xl font-semibold tracking-tight text-navy-900 md:text-4xl lg:text-5xl">
          Compliance expertise across sectors
        </h2>
      </Reveal>

      <motion.div
        initial="hidden"
        whileInView="show"
        viewport={{ once: false, margin: "-60px" }}
        variants={{ hidden: {}, show: { transition: { staggerChildren: 0.04 } } }}
        className="mt-12 flex flex-wrap gap-3"
      >
        {INDUSTRIES.map((ind, i) => (
          <motion.span
            key={ind}
            variants={{
              hidden: { opacity: 0, scale: 0.9, y: 10 },
              show: {
                opacity: 1,
                scale: 1,
                y: [0, -4, 0],
                transition: {
                  duration: 0.4,
                  y: { duration: 2.6, repeat: Infinity, ease: "easeInOut", delay: 0.4 + i * 0.1 },
                },
              },
            }}
            className={`cursor-default rounded-full border border-navy-900/12 bg-white px-6 py-3 text-base font-medium text-navy-800 transition-[transform,background-color,color,border-color] duration-300 hover:-translate-y-1 ${
              i % 2 === 0
                ? "hover:border-navy-900 hover:bg-navy-900 hover:text-white"
                : "hover:border-emerald2-600 hover:bg-emerald2-600 hover:text-white"
            }`}
            data-testid={`industry-tag-${i}`}
          >
            {ind}
          </motion.span>
        ))}
      </motion.div>
    </div>
  </section>
);
